export default __webpack_public_path__ + "static/media/balmain-3.600ba530.jpg";